<div class="c-tags-group" [ngClass]="size">
    <app-tag-group *ngFor="let tag of maxTags" [tag]="tag" [size]="size" [iconClass]="iconClass"></app-tag-group>
    <app-tag-group *ngIf="hasMore" class="c-tags-group__more" [size]="size" [tag]="more"></app-tag-group>
</div>
